import './article.less'
import m from 'mithril'
import {getThemesAndTagsFromLists} from 'util/tags'
import ContentContainer from 'views/layout/contentcontainer'
import ContentPage from 'views/pages/contentpage'
import {ArticleType} from 'views/partials/features/articlelink'
import ArticlesContainer from 'views/partials/features/articlescontainer'
import Share from 'views/partials/share'
import TagLink from 'views/layout/taglink'
import Spacer from 'views/partials/spacer'

export default class Article extends ContentPage<{
	sector: Array<string>
	policy: Array<string>
	tags: Array<string>
	lists: any
	related: {articles: Array<ArticleType>}
}> {
	current

	onupdate() {
		if (this.current !== this.attrs.data.url) {
			window.scrollTo(0, 0)
			this.current = this.attrs.data.url
		}
	}

	viewContent() {
		const {related, channel} = this.attrs.data
		return m('.article-bottom', [
			m('.article-bottom-content', [
				this.tagsView(),
				m('.article-bottom-content-links', m(Share, {mod: 'rounded'}))
			]),
			m(Spacer),
			m(ArticlesContainer, {related, mod: 'articledetail', channel})
		])
	}
	tagsView() {
		const {sector, policy, tags, lists} = this.attrs.data
		return m('.article-bottom-content-tags',
			getThemesAndTagsFromLists(lists, policy, sector, tags).map(tag =>
				m(TagLink, {text: tag, mod: 'bigtag'})
			)
		)
	}

	viewBottom() {
		const {related, channel} = this.attrs.data
		return [
			m('.article-spacer'),
			m(ContentContainer,
				{mod: 'article'},
				m(ArticlesContainer, {related, mod: 'articledetail', channel})
			)
		]
	}
}
